import { Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { TemplateComponent } from './template/template.component';
import { AuthGuard } from './guards/auth.guard';
import { UploadComponent } from './upload/upload.component';
import { AppleIdDoneComponent } from './login/apple-id-done/login-apple-id-done.components';

export const routes: Routes = [
  {
    path: 'login',
    children: [
      {
        path: '',
        component: LoginComponent
      },
      {
        path: 'apple-id/done',
        component: AppleIdDoneComponent
      }
    ]
  },
  {
    path: 'app',
    component: TemplateComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'upload',
        component: UploadComponent,
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'app/upload',
  },
];
